var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmexLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6584 11.0449H22.0894L18.4547 3H15.6466L12 11.0449H14.3829L15.088 9.40164H18.9533L19.6584 11.0449ZM28.58 11.0449H26.6964L24.4601 5.09142V11.0449H22.3198V3H25.7598L27.6684 8.12559L29.565 3H32.9689V11.0449H30.8296V5.09142L28.58 11.0449ZM23.4573 12.9551V14.7595H18.6925V16.0699H23.3481V17.8275H18.6925V19.1957H23.4573V21H16.5281V12.9551H23.4573ZM33.0007 21H30.2898L28.272 18.5055L26.2662 21H23.6284L27.0194 16.9885L23.6164 12.9551H26.3263L28.3321 15.426L30.3379 12.9551H32.9766L29.5727 16.943L33.0007 21ZM17.0083 4.89626L15.8289 7.65448H18.1997L17.0083 4.89626Z",
    fill: "#006FAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexLight);
export default __webpack_public_path__ + "static/media/amex-light.40d5ab7a1c8a796500bbfbb991cb4fa3.svg";
export { ForwardRef as ReactComponent };